import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Breadcrumbs, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import * as C from "components";
import { setCurrentPage, getPicTreeRegularSeasonPageData } from "actions";
import SeasonSelector from "components/PicTree/RegularSeason/SeasonSelector";
import RegularSeasonKpiCards from "components/PicTree/RegularSeason/RegularSeasonKpiCards";
import RegularSeasonDailyTrendChart from "components/PicTree/RegularSeason/RegularSeasonDailyTrendChart";
import RegularSeasonByCompanyTable from "components/PicTree/RegularSeason/RegularSeasonByCompanyTable";
import RegularSeasonSeasonShotsChart from "components/PicTree/RegularSeason/RegularSeasonSeasonShotsChart";

const useStyles = makeStyles((theme) => ({
  breadcrumbs: {
    marginTop: 16,
    minHeight: 30,
  },
  topBar: {
    marginTop: -16,
    marginBottom: 8,
  },
  sectionGap: {
    marginTop: theme.spacing(2),
  },
}));

const PicTreeRegularSeasonOverview = ({
  setCurrentPage,
  getPicTreeRegularSeasonPageData,
  selectedSeasonId = "regular-season-1",
  selectedSeasonIds = ["regular-season-1"],
  seasonOptions = [],
  companyOptions = [],
  selectedCompanyCode = "NTT_ME",
  kpis = [],
  trend = {
    date: [],
    uniqueShots: [],
    reviewerOk: [],
    uniqueShooters: [],
  },
  trendLoading = true,
  seasonChart = {
    labels: [],
    series: [],
  },
  companyRows = [],
  companyRowsLoading = true,
  seasonChartLoading = true,
}) => {
  const classes = useStyles();
  const [currentSeasonIds, setCurrentSeasonIds] = useState(
    Array.isArray(selectedSeasonIds) && selectedSeasonIds.length > 0
      ? selectedSeasonIds
      : [selectedSeasonId]
  );

  useEffect(() => {
    setCurrentPage(window.location.pathname);
    const nextSeasonId = currentSeasonIds[0] || selectedSeasonId;
    getPicTreeRegularSeasonPageData({
      selectedSeasonId: nextSeasonId,
      selectedSeasonIds: currentSeasonIds,
    });
  }, [currentSeasonIds, getPicTreeRegularSeasonPageData, setCurrentPage, selectedSeasonId]);

  const handleSeasonChange = (event) => {
    const nextSeasonIds = event.target.value;
    setCurrentSeasonIds(Array.isArray(nextSeasonIds) ? nextSeasonIds : [nextSeasonIds]);
  };

  const selectedCompany = companyOptions.find((item) => item.value === selectedCompanyCode);

  return (
    <Fragment>
      <C.ContentWrapper>
        <Grid
          container
          spacing={1}
          direction="row"
          className={classes.topBar}
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item xs={12} md={6}>
            <Breadcrumbs separator="›" className={classes.breadcrumbs}>
              <Typography>PicTrée 全体</Typography>
              <Typography variant="body1">Regularシーズン</Typography>
              <Typography variant="body1">概要</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid item xs={12} md={6}>
            <SeasonSelector
              selectedSeasonIds={currentSeasonIds}
              seasonOptions={seasonOptions}
              selectedCompanyLabel={selectedCompany ? selectedCompany.label : "NTT ME"}
              onSeasonChange={handleSeasonChange}
            />
          </Grid>
        </Grid>

        <Grid container spacing={1} className={classes.sectionGap}>
          <Grid item xs={12}>
            <RegularSeasonKpiCards kpis={kpis} />
          </Grid>
        </Grid>

        <Grid container spacing={1} className={classes.sectionGap}>
          <Grid item xs={12}>
            <RegularSeasonDailyTrendChart trend={trend} loading={trendLoading} />
          </Grid>
        </Grid>

        <Grid container spacing={2} className={classes.sectionGap}>
          <Grid item xs={12} md={6}>
            <RegularSeasonByCompanyTable rows={companyRows} loading={companyRowsLoading} />
          </Grid>
          <Grid item xs={12} md={6}>
            <RegularSeasonSeasonShotsChart seasonChart={seasonChart} loading={seasonChartLoading} />
          </Grid>
        </Grid>
      </C.ContentWrapper>
    </Fragment>
  );
};

PicTreeRegularSeasonOverview.propTypes = {
  classes: PropTypes.object,
  setCurrentPage: PropTypes.func,
  getPicTreeRegularSeasonPageData: PropTypes.func,
  selectedSeasonId: PropTypes.string,
  selectedSeasonIds: PropTypes.array,
  seasonOptions: PropTypes.array,
  companyOptions: PropTypes.array,
  selectedCompanyCode: PropTypes.string,
  kpis: PropTypes.array,
  trend: PropTypes.object,
  trendLoading: PropTypes.bool,
  seasonChart: PropTypes.object,
  companyRows: PropTypes.array,
  companyRowsLoading: PropTypes.bool,
  seasonChartLoading: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  loading: state.pictreeRegularSeason.loading,
  selectedSeasonId: state.pictreeRegularSeason.selectedSeasonId,
  selectedSeasonIds: state.pictreeRegularSeason.selectedSeasonIds,
  selectedCompanyCode: state.pictreeRegularSeason.selectedCompanyCode,
  seasonOptions: state.pictreeRegularSeason.seasonOptions,
  companyOptions: state.pictreeRegularSeason.companyOptions,
  kpis: state.pictreeRegularSeason.kpis,
  trend: state.pictreeRegularSeason.trend,
  trendLoading: state.pictreeRegularSeason.trendLoading,
  seasonChart: state.pictreeRegularSeason.seasonChart,
  companyRows: state.pictreeRegularSeason.companyRows,
  companyRowsLoading: state.pictreeRegularSeason.companyRowsLoading,
  seasonChartLoading: state.pictreeRegularSeason.seasonChartLoading,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (param) => dispatch(setCurrentPage(param)),
  getPicTreeRegularSeasonPageData: (param) => dispatch(getPicTreeRegularSeasonPageData(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PicTreeRegularSeasonOverview);
